import React, { FC, useEffect } from 'react'
import { CustomAlert } from '../../../../states/types/setting'
import { useHistory } from 'react-router-dom'
import { URL } from '../../../constants/url'

const CustomAlert: FC = () => {
  const history = useHistory()

  useEffect(() => {
    history.push(URL.CUSTOM_ALERT.path)
  }, [])

  return (
    <>
    </>
  )
}

export default CustomAlert
